import { put, takeEvery, call, select } from 'redux-saga/effects';
import { HttpErrorHandler } from '../../managers/http-utils';
import { IWorkspace } from '../../models/IWorkspaces';
import { OpenDataProvidersProxy } from '../../proxies/OpenDataProvidersProxy';
import { getWorkspace } from '../../store/selectors/WorkspaceSelectors';
import { WorkspaceActionType } from '../store/WokspaceActionType';


export default function* watchWorkspaceOpenData() {
  yield takeEvery(WorkspaceActionType.OPENDATA_PROVIDERS_LOAD, handleLoadOpenDataProviders);
  yield takeEvery(WorkspaceActionType.OPENDATA_PROVIDERS_EXTRACT, handleExtractOpenData);
}

export function* handleLoadOpenDataProviders() {
  const workspace: IWorkspace = yield select(getWorkspace);

  if (workspace && workspace.id) {
    try {
      yield put({
        type: WorkspaceActionType.OPENDATA_PROVIDERS_LOADING,
        providersLoading: true,
      });

      const response = yield call(OpenDataProvidersProxy.getOpenDataProviders, workspace.id);

      if (response && response.status === 200 && response.data) {
        yield put({
          type: WorkspaceActionType.OPENDATA_PROVIDERS_SET,
          providers: response.data,
        });
      }
    } catch (error) {
      HttpErrorHandler('Failed to fetch open data providers.', error);
    } finally {
      yield put({
        type: WorkspaceActionType.OPENDATA_PROVIDERS_LOADING,
        providersLoading: false,
      });
    }
  }
}

export function* handleExtractOpenData(action) {
  const workspace: IWorkspace = yield select(getWorkspace);
  const { openDataExtraction } = action;
  if (workspace && workspace.id) {
    try {
      yield call(OpenDataProvidersProxy.extractData, workspace.id, openDataExtraction);
    } catch (error) {
      HttpErrorHandler('Failed to extract open data.', error);
    }
  }
}
